<div
  class="truncate-wrapper"
  [ngbTooltip]="text"
  [placement]="tooltipPlacement"
  container="body"
>
  <span class="truncate-text" [textContent]="text"></span>
</div>
